import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type SuppressedEmail = {
  email: string;
  reason: string;
  created_at: string;
};

export type SuppressedEmailsMap = Map<string, SuppressedEmail>;

export const useSuppressedEmails = (enabled: boolean = true) => {
  return useQuery<SuppressedEmailsMap>({
    queryKey: ["suppressed-emails"],
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("suppressed_emails")
        .select("email, reason, created_at")
        .order("created_at", { ascending: false });
      if (error) throw error;
      const map: SuppressedEmailsMap = new Map();
      for (const row of data ?? []) {
        map.set(row.email.toLowerCase(), row as SuppressedEmail);
      }
      return map;
    },
  });
};

export const reasonLabel = (reason: string): string => {
  switch (reason) {
    case "unsubscribe":
      return "Wypisał się z maili";
    case "bounce":
      return "Mail odbity (bounce)";
    case "complaint":
      return "Zgłoszono jako spam";
    default:
      return `Wstrzymane maile (${reason})`;
  }
};
